import { Action, createAction, props } from '@ngrx/store';
import {
    AppCurrenciesDto,
    AppSettingsDto,
    AppUserDto,
    AppWalkMeParametersDto,
    ClientCustomizationDataDto,
    EnterpriseUserDataDto,
    ExternalScriptDto,
    ListItemCategoryDto,
    ListProductDto,
    ListVersionedProductDto,
    LocaleDto,
    SchedulerConfig,
    UserAppFeaturesDto,
    UserStateDto
} from 'src/app/services/api.services';
import { AppError } from '../../shared/utils';
import { State } from './app.reducer';
import { TrgUserClaims } from 'src/app/shared/models/app-user';

export interface SetUserData {
  user: AppUserDto;
  userClaims: Record<string, string[]>;
  userProfileClaims: Record<string, string>
};

export interface AppInitParams {
  userData?: SetUserData
};

export const loadError = createAction('[App] Load Error', props<{ error: AppError }>());
export const loadSuccess = createAction('[App] Load Success', props<{
    user: AppUserDto,
    userClaims: any,
    userProfileClaims: any,

    enterpriseUserData: EnterpriseUserDataDto,
    userState: UserStateDto,
    
    settings: AppSettingsDto,
    features: UserAppFeaturesDto,
    
    products: ListVersionedProductDto[],
    itemCategories: ListItemCategoryDto[],
    
    schedulerConfig: SchedulerConfig

    walkMeParameters: AppWalkMeParametersDto,
    externalScripts: ExternalScriptDto[],

    clientCustomization: ClientCustomizationDataDto,
    locales: LocaleDto[]
}>());

export const loadSettings = createAction(
  '[App] Load Settings');
export const loadSettingsSuccess = createAction(
  '[App] Load Settings Success', props<AppSettingsDto>());

export const loadClientCustomization = createAction(
  '[App] Load ClientCustomization');
export const loadClientCustomizationSuccess = createAction(
  '[App] Load ClientCustomization Success', props<ClientCustomizationDataDto>());

export const logout = createAction(
  '[App] Logout'
);
export const error = createAction(
  '[App] error',
  props<{ error?: AppError }>()
);
export const noop = createAction(
  '[App] noop'
);

export const unauthorized = createAction(
  '[App] Unauthorized',
  props<{ error?: AppError }>()
);

export const setPageComponent = createAction(
  '[App] Set Page Component',
  props<{ component: string | Function }>()
);

export const updateUserState = createAction(
  '[App] Update User State',
  props<{ userState: UserStateDto, callbackAction?: Action }>()
);

export const saveUserState = createAction(
  '[App] Save UserState',
  props<{ userState: UserStateDto, callbackAction?: Action }>()
);
export const saveUserStateSuccess = createAction(
  '[App] Save UserState Success',
  props<{ userState: UserStateDto, callbackAction?: Action }>()
);
export const saveUserStateFailure = createAction(
  '[App] Save UserState Failure',
  props<{ error: AppError }>()
);
